import { escapeRegExp } from "lodash";

export function prepareSearchText(rawText: string): string {
  // add logic if necessary
  return rawText;
}

export function highlightSearchText(text: string, rawSearchText: string): string {
  const charactersToDelete = escapeRegExp("'`\"\\@#$%^&()_.,!?<>:;[]{}/|*+-=");
  const preparedText = prepareSearchText(rawSearchText);
  const searchRegexp = escapeRegExp(
    preparedText.replace(new RegExp(`^[\\s${charactersToDelete}]+|[\\s${charactersToDelete}]+$`), ""),
  );

  return text.replace(new RegExp(searchRegexp, "i"), "<span class='font-extrabold'>$&</span>");
}

/**
 * Determines if a URL requires Rapid Order transformation
 * @param url - The URL to check
 * @returns true if URL contains rapid-order pattern (case-insensitive)
 */
export const shouldApplyRapidOrderTransform = (url: string): boolean => {
  return url.toLowerCase().includes("/rapid-order/");
};

/**
 * Transforms a Rapid Order page URL to cart query parameter format
 * @param url - The original page URL (e.g., /rapid-order/upload-a-cart)
 * @returns Transformed URL (e.g., /cart?rapidOrder=upload-a-cart)
 */
export const transformRapidOrderUrl = (url: string): string => {
  const chunks = url.split("/").filter((segment) => segment.length > 0);
  const pageSlug = chunks[chunks.length - 1];
  const baseUrl = window.location.origin;
  return `${baseUrl}/cart?rapidOrder=${pageSlug}`;
};
